import React, { useEffect, Component } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './hard-milling/HeroSection';
import { IntroSection } from './hard-milling/IntroSection';
import { WhatIsHardMillingSection } from './hard-milling/WhatIsHardMillingSection';
import { ComponentsOfHardMillingSection } from './hard-milling/ComponentsOfHardMillingSection';
import { MikronDNASection } from './hard-milling/MikronDNASection';
import { MikronMachinesSection } from './hard-milling/MikronMachinesSection';
import { CharacteristicsSection } from './hard-milling/CharacteristicsSection';
import { BottomLinksSection } from './hard-milling/BottomLinksSection';
export function HardMillingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2498">
      <SeoBar data-id="element-2499" />
      <Header data-id="element-2500" />
      <main className="flex-grow" data-id="element-2501">
        <div className="w-full bg-gray-50 pb-20" data-id="element-2502">
          <HeroSection data-id="element-2503" />
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-16" data-id="element-2504">
            <IntroSection data-id="element-2505" />
            <WhatIsHardMillingSection data-id="element-2506" />
            <ComponentsOfHardMillingSection data-id="element-2507" />
            <MikronDNASection data-id="element-2508" />
            <MikronMachinesSection data-id="element-2509" />
            <CharacteristicsSection data-id="element-2510" />
            <BottomLinksSection data-id="element-2511" />
          </div>
        </div>
      </main>
      <Footer data-id="element-2512" />
    </div>;
}